<template>
  <div class="poster">

    <vue-canvas-poster :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    <img :src="img" width="100%" />

    <Floating />
  </div>
</template>

<script>
  import { VueCanvasPoster } from 'vue-canvas-poster'

  export default {
    components: {
      VueCanvasPoster,
    },
    name: 'share',
    data() {
      return {
        painting: {
          width: `${document.documentElement.clientWidth}px`,
          height: `${document.documentElement.clientWidth * 1.777}px`,
          background: "#f4f5f7",
          views: [
            {
              type: "image", //海报背景
              url: require("@/assets/images/rmm_bg_1.jpg"),
              css: {
                width: "100%",
                height: `${document.documentElement.clientWidth * 1.777}px`,
                top: "0",
                left: "0",
                mode: "aspectFill",
              },
            },
            {
              type: "image", //海报头像
              //url: require("@/assets/images/def_user.jpg"),
              url: this.$store.state.avatar,
              css: {
                width: `${document.documentElement.clientWidth / 5.5}px`,
                height: `${document.documentElement.clientWidth / 5.5}px`,
                top: `48px`,
                left: `154px`,
                borderRadius: `50px`,
                borderColor: '#fff',
                borderWidth: '2px',
              },
            },
            {
              type: "text",  //昵称
              text: this.$store.state.nickname,
              //text: '签约白转黑，秃发，无效全额退款',
              css: [
                {
                  top: `130px`,
                  left: `192px`,
                  color: "#663B17",
                  fontSize: "16px",
                  align: 'center',
                },
              ],
            },
            {
              type: "qrcode", //二维码
              content: process.env.DOMAIN_NAME+"register/index?hid="+this.$store.state.hid,
              css: {
                top: `190px`,
                left: `83px`,
                color: "#000000",
                background: `#ffffff`,
                borderWidth: '8px',
                borderColor: '#ffffff',
                width: `${document.documentElement.clientWidth / 1.7}px`,
                height: `${document.documentElement.clientWidth / 1.7}px`,
              },
            },
          ],
        },
        img: "",
      };
    },
    created() {},
    mounted() {},
    methods: {
      success(src) {
        this.img = src;
      },
      fail(err) {
        console.log("fail", err);
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/agency/share.vue